import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import { FormattedMessage } from 'react-intl';
import { RootPage } from 'modules/rootPage';
import AirflowRouteProps from './AirflowRouteProps';

export const rootRoute: AirflowRouteProps = {
  path: '/',
  component: RootPage,
  exact: false,
  title: <FormattedMessage id="appTitle" />
};
const tiRoutes: AirflowRouteProps[] = [rootRoute];

const progress = <LinearProgress />;

export const Routes: React.FC = () => {
  return (
    <Suspense fallback={progress}>
      <Switch>
        {tiRoutes.map((route: AirflowRouteProps) => (
          <Route
            key={Array.isArray(route.path) ? route.path[0] : route.path}
            {...route}
          />
        ))}
      </Switch>
    </Suspense>
  );
};
